import { Component, ElementRef, HostListener, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { UrlService } from '../../services/url.service';
import { AmenitiesService } from '../../services/amenities.service';
import { ApiClientService } from '../../services/api-client.service';

declare const toastr: any;

@Component({
    selector: 'settings-integrations-category-filter',
    templateUrl: './settings-integrations-category-filter.component.html',
    styleUrls: ['./settings-integrations-category-filter.component.scss']
})
export class SettingsIntegrationsCategoryFilterComponent implements OnInit {
    showDropdown = false;
    @Output() onAmenitiesChange: EventEmitter<any> = new EventEmitter();

    @ViewChild('approvedCheckbox') approved: ElementRef;
    @ViewChild('pendingCheckbox')  pending:  ElementRef;
    @ViewChild('expiredCheckbox')  expired:  ElementRef;
    @ViewChild('declinedCheckbox') declined: ElementRef;
    amenities: Array<any> = [];
    constructor(private urlService: UrlService,
        public amenitiesService: AmenitiesService,
        public api: ApiClientService,
    ) { }

    ngOnInit() {
        this.urlService.onUrlChange.subscribe(_ => {
            const status = this.urlService.queryParams['status'];
            if (status) {
                this.approved.nativeElement.checked = status.indexOf('approved') !== -1;
                this.pending.nativeElement.checked = status.indexOf('pending') !== -1;
                this.expired.nativeElement.checked = status.indexOf('expired') !== -1;
                this.declined.nativeElement.checked = status.indexOf('declined') !== -1;
            } else {
                this.approved.nativeElement.checked = false;
                this.pending.nativeElement.checked = false;
                this.expired.nativeElement.checked = false;
                this.declined.nativeElement.checked = false;
            }
        });
    }

    changeFilter() {
        const approvedValue = this.approved.nativeElement.checked;
        const pendingValue = this.pending.nativeElement.checked;
        const expiredValue = this.expired.nativeElement.checked;
        const declinedValue = this.declined.nativeElement.checked;

        if (!approvedValue && !pendingValue && !expiredValue && !declinedValue) {
            this.urlService.queryParams['status'] = null;
        } else {
            let status = '';
            if (approvedValue) status += 'approved,';
            if (pendingValue) status += 'pending,';
            if (expiredValue) status += 'expired,';
            if (declinedValue) status += 'declined,';
            this.urlService.queryParams['status'] = status.slice(0, -1);
        }
        this.urlService.setQueryParams(null, 1);
        this.amenitiesService.getData();
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('settings-integrations-category-filter')) this.showDropdown = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/settings-integrations-category-filter/settings-integrations-category-filter.component.ts